import { useEditor, useValue } from '@tldraw/editor'
import { useShowCollaborationUi } from '../../hooks/useIsMultiplayer'
import {
	ArrangeMenuSubmenu,
	ClipboardMenuGroup,
	ConversionsMenuGroup,
	CursorChatItem, DownloadMenuGroup,
	EditMenuSubmenu, ImageBoardMenuGroup, LeftMenuCopyGroup, LeftMenuGroup,
	MoveToPageMenu,
	ReorderMenuSubmenu,
	SelectAllMenuItem, ShowDetailMenuGroup,
} from '../menu-items'
import { TldrawUiMenuGroup } from '../primitives/menus/TldrawUiMenuGroup'
import {DownLoad, ViewDetail} from "moodboard/src/icons";
import {store} from "moodboard/src/store";
import {setSelectCanvasImage} from "moodboard/src/store/taskSlice";

/** @public @react */
export function DefaultContextMenuContent() {
	const editor = useEditor()
	const showCollaborationUi = useShowCollaborationUi()

	const selectToolActive = useValue(
		'isSelectToolActive',
		() => editor.getCurrentToolId() === 'select',
		[editor]
	)
	const isSinglePageMode = useValue('isSinglePageMode', () => editor.options.maxPages <= 1, [
		editor,
	])

	if (!selectToolActive) return null

	return (
		<>
{/*			{showCollaborationUi && <CursorChatItem />}
			<TldrawUiMenuGroup id="modify">
				<EditMenuSubmenu />
				<ArrangeMenuSubmenu />
				<ReorderMenuSubmenu />
				{!isSinglePageMode && <MoveToPageMenu />}
			</TldrawUiMenuGroup>
			<ClipboardMenuGroup />
			<ConversionsMenuGroup />*/}
			<TldrawUiMenuGroup id="select-all">
				<SelectAllMenuItem />
			</TldrawUiMenuGroup>

			<LeftMenuCopyGroup />

			<LeftMenuGroup />
		</>
	)
}
